export default __webpack_public_path__ + "images/aa5c7e251cbaeed4532c27575b6bfae3-historic.webp";